import { api } from '@/api';

export interface ImprovePromptQuestionAnswer {
  question: string;
  answer: string;
}

export interface ImprovePromptRequest {
  prompt: string;
  chatId: string | null;
  questions?: ImprovePromptQuestionAnswer[];
}

export interface ImprovePromptResponse {
  improvedPrompt: string;
}

const improvePromptApi = api.injectEndpoints({
  endpoints: (builder) => ({
    improvePrompt: builder.mutation<ImprovePromptResponse, ImprovePromptRequest>({
      query: ({ prompt, chatId, questions }) => ({
        url: '/chat/v1/improve-prompt',
        method: 'POST',
        body: {
          currentPrompt: prompt,
          chatId: chatId,
          questions: questions ?? [],
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useImprovePromptMutation } = improvePromptApi;
